






































import {Component} from 'vue-property-decorator';
import {usersModule} from '@/store/modules/users';
import {SET_USERS} from '@/store/mutationTypes';
import {mixins} from 'vue-class-component';
import SnackbarMixin from '@/mixins/SnackbarMixin';
import LoadingMixin from '@/mixins/LoadingMixin';
import Swal from 'sweetalert2';
import formBiodata from '@/components/Users/FormBiodata.vue';
import FormAddress from '@/components/Users/FormAddress.vue';
import FormEmergency from '@/components/Users/FormEmergency.vue';
import FormHealth from '@/components/Users/FormHealth.vue';

@Component({
  components: {formBiodata, FormAddress, FormEmergency, FormHealth},
})
export default class AdminsIndex extends mixins(LoadingMixin, SnackbarMixin) {
  @usersModule.Mutation(SET_USERS) setUsers!: Function;

  getColor(status: number) {
    return status === 1 ? 'success' : 'error';
  }

  profileEdit = true;
  healthEdit = true;
  addressEdit = true;
  e6 = 1;
  emergencyEdit = true;
  listProvince = [];
  listcity = [];
  listdistrict = [];
  listsubDistrict = [];
  listpenyakit = [];
  radioGroup = null;

  goToNext(values: number) {
    this.e6 = values;
  }

  destroyed() {
    this.setUsers([]);
  }
}
